// extracted by mini-css-extract-plugin
export default {"resources":"FacilitatorAccordion_resources__-LsGL","resources_wrapper":"FacilitatorAccordion_resources_wrapper__RHtt7"};